export default __webpack_public_path__ + "static/597-074096a25e638813cabdd48f9b16c523.gif";